import { ActionButton, SplitButtonActionItem } from '@components/button/types'
import ListItemIcon from '@mui/material/ListItemIcon'
import Stack from '@mui/material/Stack'

type MoreActionsMenuContentProps = {
  action: ActionButton | SplitButtonActionItem
}
const MoreActionsMenuContent: React.FC<MoreActionsMenuContentProps> = ({ action }) => (
  <>
    {'startIcon' in action && action.startIcon && (
      <ListItemIcon sx={{ '& .MuiSvgIcon-root': { color: action.color } }}>
        {action.startIcon}
      </ListItemIcon>
    )}
    <Stack justifyContent="space-between" alignItems="center" direction="row" width="100%">
      {action.name}
      {'endIcon' in action && action.endIcon && (
        <ListItemIcon
          sx={{
            '& .MuiSvgIcon-root': { color: action.color },
            minWidth: 'unset !important',
          }}>
          {action.endIcon}
        </ListItemIcon>
      )}
    </Stack>
  </>
)
export default MoreActionsMenuContent
